import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Port Elizabeth" />
        <footer>
          This project was coded by <a href="/">VuvuM</a> and is{" "}
          <a
            href="https://github.com/VuvuM03/weather-react-project"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on Github
          </a>
        </footer>
      </div>
    </div>
  );
}
